export default __webpack_public_path__ + "static/media/Landing-P6-Ulet-Ifansasti-Greenpeace.3b6ca37a.jpg";